import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Input } from '@progress/kendo-react-inputs';
import * as React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import useConfiguration from '../../../../hooks/useConfiguration';
import Maps from '../../../common/Maps';
import { patients, rooms, therapists, treatments } from '../data';

export const TitleEditor = (props) => {
  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.id,
      });
    }
  };
  return (
    <DropDownList
      onChange={handleChange}
      value={patients.find((p) => p.id === props.value)}
      data={patients}
      dataItemKey={'id'}
      textField={'name'}
    />
  );
};
export const TreatmentEditor = (props) => {
  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.value,
      });
    }
  };
  return (
    <DropDownList
      onChange={handleChange}
      value={treatments.find((t) => t.value === props.value)}
      data={treatments}
      dataItemKey={'value'}
      textField={'text'}
    />
  );
};
export const TherapistEditor = (props) => {
  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.value,
      });
    }
  };
  return (
    <DropDownList
      disabled={true}
      onChange={handleChange}
      value={therapists.find((t) => t.value === props.value)}
      data={therapists}
      dataItemKey={'value'}
      textField={'name'}
    />
  );
};
export const RoomEditor = (props) => {
  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.id,
      });
    }
  };
  return (
    <DropDownList
      onChange={handleChange}
      value={rooms.find((r) => r.id === props.value)}
      data={rooms}
      dataItemKey={'id'}
      textField={'title'}
    />
  );
};

export const AppointmentType = (props) => {
  const appointmentData = useSelector(
    (state) => state.jobOpportunity.appointmentData
  );

  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.id,
      });
    }
  };

  return (
    <DropDownList
      onChange={handleChange}
      value={appointmentData.find((t) => t.id === props.value)}
      data={appointmentData}
      dataItemKey={'id'}
      textField={'name'}
      style={{
        background: '#fff',
        border: `${props.valid === false ? '1px solid red' : ''}`,
      }}
    />
  );
};

export const ShiftLength = (props) => {
  const shiftLengthData = useSelector(
    (state) => state.jobOpportunity.shiftLengthData
  );

  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.id,
      });
    }
  };

  return (
    <DropDownList
      onChange={handleChange}
      value={shiftLengthData.find((t) => t.id === props.value)}
      data={shiftLengthData}
      dataItemKey={'id'}
      textField={'name'}
      style={{
        background: '#fff',
        border: `${props.valid === false ? '1px solid red' : ''}`,
      }}
    />
  );
};

export const ShowMap = (props) => {
  const config = useConfiguration();
  const [latitude, setLatitude] = useState('38.90809416753823');
  const [longitude, setLongitude] = useState('-77.05809609374998');

  const setLatLng = (e) => {
    if (e.latLng.lat() && e.latLng.lng()) {
      setLatitude(e.latLng.lat());
      setLongitude(e.latLng.lng());
      if (props.onChange) {
        props.onChange.call(undefined, {
          value: { lat: e.latLng.lat(), lng: e.latLng.lng() },
        });
      }
    }
  };

  return (
    <>
      {config.mapURL && (
        <Maps
          googleMapURL={config.mapURL}
          containerElement={<div style={{ height: '400px' }} />}
          mapElement={<div style={{ height: '100%' }} />}
          loadingElement={<div style={{ height: `100%` }} />}
          lat={latitude}
          lng={longitude}
          setLatLng={setLatLng}
        />
      )}
    </>
  );
};

export const PhoneNumberInput = (props) => {
  const formatPhoneNumber = (value) => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  };

  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: formatPhoneNumber(event.value),
      });
    }
  };

  return (
    <Input
      onChange={handleChange}
      value={props.value}
      style={{ border: `${props.valid === false ? '1px solid red' : ''}` }}
    />
  );
};

export const ZipCodeInput = (props) => {
  const formatZipcode = (value) => {
    if (!value) return value;
    const ZipcodeNumber = value.replace(/[^\d]/g, '');
    if (ZipcodeNumber.length <= 6) {
      return ZipcodeNumber;
    } else {
      return `${ZipcodeNumber.slice(0, 6)}`;
    }
  };

  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: formatZipcode(event.value),
      });
    }
  };

  return (
    <Input
      onChange={handleChange}
      value={props.value}
      style={{ border: `${props.valid === false ? '1px solid red' : ''}` }}
    />
  );
};
